import React from "react";
import DealTopFields from "@/pages/deals/components/DealTopFields";
import DealDetailFields from "@/pages/deals/components/DealDetailFields/DealDetailFields";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import Ownership from "@/components/layouts/Ownership";
import DealKPIs from "@/pages/deals/components/DealKPIs";
import NextSteps from "@/components/layouts/NextSteps/NextSteps";
import { DealData, DealStatus } from "@/pages/deals/types";
import PeopleSection from "@/components/layouts/QuickView/PeopleSection/PeopleSection";
import FromDreamer from "@/components/layouts/FromDreamer/FromDreamer";

interface Props {
  deal: DealData | undefined;
  onUpdateDealField: (
    field: string,
    newValue: string | number | boolean | string[],
    additionalFields?: {
      [fieldName: string]: string | number;
    }
  ) => void;
  handleOpenCloseDealModal: (
    status: DealStatus.CLOSED_LOST | DealStatus.CLOSED_WON,
    selectedReason?: number | null,
    statusNotes?: string | null,
    closedLostReasonText?: string | null
  ) => void;
  handleOpenQuestionnaire: ((questionnaireId?: string) => void) | undefined;
  isDrawerOpen: boolean;
}

const DealQuickViewContent: React.FC<Props> = ({
  deal,
  onUpdateDealField,
  handleOpenCloseDealModal,
  handleOpenQuestionnaire,
  isDrawerOpen
}) => {
  return (
    <div className="flex flex-col w-full gap-4">
      <DealTopFields
        className="flex-wrap gap-0 pl-5 pr-0"
        key={deal?.id}
        deal={deal}
        onUpdateField={onUpdateDealField}
        handleOpenCloseDealModal={handleOpenCloseDealModal}
      />
      <div className="flex flex-col w-full gap-4 pl-5">
        <DealKPIs
          key={deal?.id}
          deal={deal}
          containerClassName="grid-cols-[repeat(auto-fill,minmax(12rem,12rem))]"
          isQuickView
          onOpenQuestionnaire={handleOpenQuestionnaire}
          onUpdateField={onUpdateDealField}
        />
        <NextSteps
          className="w-full px-4"
          entity={deal}
          entityType={EntityType.DEAL}
          isQuickView
        />
        <FromDreamer
          entityType={EntityType.DEAL}
          entityId={deal?.id || ""}
          alerts={deal?.alerts}
          className="w-full px-4"
          isQuickView
          showSummary={true}
        />
        <DealDetailFields
          className="w-full px-4"
          deal={deal}
          onUpdateField={onUpdateDealField}
          isDrawerOpen={isDrawerOpen}
          isQuickView
        />
        <PeopleSection deal={deal} />
        <Ownership
          entity={deal}
          entityType={EntityType.DEAL}
          onUpdateField={onUpdateDealField}
          isQuickView
        />
      </div>
    </div>
  );
};

export default DealQuickViewContent;
